import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import './cardCount.css';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: '#e2e1e1',
    borderRadius: 10,
    maxWidth: 150,
    maxHeight: 100,
  },
}));

export default function CardCount(props) {
  const classes = useStyles();
  const { title, value, color } = props;

  return (
    <Paper
      className={classes.paper}
      style={{
        backgroundColor: color === '1' ? '#006d46' : '#2ca880',
      }}
    >
      <Typography noWrap className='value'>
        {value}
      </Typography>
      <Typography noWrap className='value'>
        {title}
      </Typography>
    </Paper>
  );
}
